import React from 'react';
import PropTypes from 'prop-types';

export const FsRootCell = ({value, row, className}) => (
  <td className={className}>
    {value}
    {row.fsRootPath2 && value !== row.fsRootPath2 ? <span> to {row.fsRootPath2}</span> : null}
  </td>
);

FsRootCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.object,
  className: PropTypes.string
};
